/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ModelCommonResponse, ModelEditProjectRequest } from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class EditProject<
  SecurityDataType = unknown
> extends HttpClient<SecurityDataType> {
  /**
   * @description edit project list
   *
   * @tags project
   * @name EditProjectCreate
   * @summary edit project
   * @request POST:/editProject
   */
  editProjectCreate = (
    request: ModelEditProjectRequest,
    params: RequestParams = {}
  ) =>
    this.request<ModelCommonResponse, any>({
      path: `/editProject`,
      method: 'POST',
      body: request,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
